import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { IControlProps, MapProps } from '.';
import { SelectButton } from '../prime';
import styles from './index.module.scss';

export interface IOptionButtonValue {
  name?: string;
  value?: string;
  icon?: string;
  obj?: any;
}

interface IProps extends IControlProps<string> { 
  storage?: IDataStorage;
  /** personalización de los items */
  itemTemplate?: (value: IOptionButtonValue) => React.ReactNode;

  /** Lista de valores */
  values: IOptionButtonValue[];
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;
  values?: IOptionButtonValue[];

  /** Indica el mensaje de error si es que existe */
  validError?: string;
}

class Index extends React.Component<IProps, IState> {
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.values !== s?.values) res.values = p.values;
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <SelectButton
            optionLabel="name" 
            optionValue="value" 
            value={this.state.value}
            className={`w-100 ${styles.ctrl} ${validError && 'p-error'} p-column.filter`}
            style={{display:'flex'}}
            options={this.state.values}
            itemTemplate={o => 
              this.props.itemTemplate ? this.props.itemTemplate(o) :
              (<>
                {o.icon ? <i className={`${o.icon}`} style={{ fontSize: '1em', width: '1em'}} /> : undefined}
                {o.name}
              </>)
            }
            // itemTemplate={o => <i className={`${o.icon}`} style={{ fontSize: '1em', width: '1em'}} />}
            onChange={(e) => this.change(e.value)}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: string) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;

    if (required && !value) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
